export const TOKEN_INFO = `TOKEN_ADMIN_ANTAR`;
